var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlug = function SvgPlug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.5 5 8.47 8.313-5.657 5.657a2 2 0 0 1-2.829 0l-5.637-5.637a2 2 0 0 1 .019-2.848zM9.07 3.414l11.314 11.314M6.95 16.706 2 21.656M16.142 2l-4.243 4.243M21.798 7.656 17.555 11.9"
  })));
};
export { SvgPlug as ReactComponent };
export default "/_next/static/chunks/svg/plug-4f3fb4e4960a54bde1ac707a088cb1c0.svg";